/* global Waypoint */
// Do not delete the above comment, it's a workaround until waypoints resolve their webpack issues.

import { Power0, Power3, Expo } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'

import SplitText from '../lib/SplitText'
import inView from 'in-view'

/* ======================================================================
 * ANIMATION HELPERS
 * ====================================================================== */

export function bindInViewTimeline ($el, timeline) {
  let offset = $el.data('offset')
  offset = typeof offset !== 'undefined' ? offset : window.innerHeight * 0.75

  const waypoint = new Waypoint({
    element: $el.get(0),
    handler: function (direction) {
      // if (!$(this.element).is(':visible')) {
      //   return
      // }
      this.disable()
      timeline.play()
    },
    offset: offset,
  })

  $el.data({ waypoint })
}

export function bindInViewTimelineStagger ($el, timeline, masterTimeline) {
  let position
  let offset = $el.data('offset')
  offset = typeof offset !== 'undefined' ? offset : window.innerHeight * 0.75
  const stagger = masterTimeline.data.stagger
  const waypoint = new Waypoint({
    element: $el.get(0),
    handler: function (direction) {
      // console.log(this.element, $(this.element).is(':visible'))
      // if (!$(this.element).is(':visible')) {
      //   return
      // }
      // console.log('should animate in')
      if (masterTimeline.isActive()) {
        var children = masterTimeline.getChildren(false)
        position = children[children.length - 1]._startTime + stagger
        if (masterTimeline.duration() * masterTimeline.progress() > position) {
          position = masterTimeline.duration() * masterTimeline.progress()
        }
      } else {
        position = '+=0'
      }

      masterTimeline.add(timeline, position)
      timeline.play()
      this.disable()
    },
    offset: offset,
  })
  $el.data({ waypoint })
}

/* ======================================================================
  * COMPONENT ANIMATIONS
  * ====================================================================== */

var bindInViewToBlocks = function () {
  // inView.offset($(window).height() / 6)
  inView('.jsa')
    .on('enter', function (el) {
      var $el = $(el)

      if ($el.hasClass('in-view')) {
        return
      }

      $el
        .addClass('in-view')
        .data('timeline')
        .play()
    })
}

export function animateComponents () {
  /* --------------------------------------------------
    * TIMELINES
    * --------------------------------------------------
    * We are first creating the timelines and then
    * we are assigning them to the related DOM elements
    * as a data attribute, in order to play them when
    * the element gets in the viewport.
    * -------------------------------------------------- */

  $('.fade-title').each(function (i, el) {
    const $el = $(el)
    const timeline = new TimelineMax({ paused: true })

    const splitText = new SplitText($el, { type: 'chars,lines' })

    timeline
      .staggerFromTo(
        splitText.chars,
        1.2,
        { x: '40px', opacity: 0 },
        { x: '0x', opacity: 1, ease: Expo.easeInOut },
        0.03
      )

    $el.data('timeline', timeline)
  })

  $('.fade-text').each(function (i, el) {
    const $el = $(el)
    const $p = $el.find('p, h3').add('.product-meta__title, .product-meta__category')
    if ($p.length === 0) {
      return
    }
    const splitText = new SplitText($p, { type: 'lines' })

    const timeline = new TimelineMax({ paused: true, delay: 0.5 })

    timeline
      .staggerFromTo(
        splitText.lines,
        0.3,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.1
      )
      .staggerFromTo(
        splitText.lines,
        0.8,
        { y: '30px' },
        { y: '0px', ease: Power3.easeOut },
        0.1,
        0
      )
      .add('milestone')
      .staggerFromTo(
        $el.find('.embed-responsive, img'),
        0.8,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.1,
        'milestone'
      )
      .staggerFromTo(
        $el.find('.embed-responsive, img'),
        0.3,
        { y: '30px' },
        { y: '0px', ease: Power3.easeOut },
        0.3,
        'milestone'
      )

    $el.data('timeline', timeline)
  })

  bindInViewToBlocks()
}



// WEBPACK FOOTER //
// ./scripts/util/animations.js